interface BrowserMetrics {
  browserLandingReferrer: string
  browserLandingUrl: string
  browserLocale: string
  browserScreenSize: string
  browserTimeZone: string
  browserUrl: string
  browserUrlTrail: string[]
  browserUserAgent: string
}

interface StatefulMetrics {
  landing?: {
    url: string
    referrer: string
  }
  urlTrail: string[]
}

export const statefulMetrics: StatefulMetrics = { urlTrail: [] }

export const capturePageMount: () => void = () => {
  statefulMetrics.urlTrail.push(window.location.href)

  if (!statefulMetrics.landing) {
    statefulMetrics.landing = {
      referrer: document.referrer,
      url: window.location.href,
    }
  }
}

const collectMetric = (f: () => string): string => {
  // Empty on server side render
  if (typeof window === 'undefined') {
    return ''
  }
  try {
    return f()
  } catch (e: unknown) {
    return JSON.stringify(e)
  }
}

export const getMetrics: () => BrowserMetrics = () => ({
  browserLandingReferrer: collectMetric(
    () => statefulMetrics.landing?.referrer || '',
  ),
  browserLandingUrl: collectMetric(() => statefulMetrics.landing?.url || ''),
  browserLocale: collectMetric(() => navigator.language),
  browserScreenSize: collectMetric(
    () => `${window.screen.width}x${window.screen.height}`,
  ),
  browserTimeZone: collectMetric(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone,
  ),
  browserUrl: collectMetric(() => window.location.href),
  browserUrlTrail: statefulMetrics.urlTrail,
  browserUserAgent: collectMetric(() => navigator.userAgent),
})
